module.exports = __webpack_public_path__ + "dist/404.8a4510fe.svg";